"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var enquiryFormErrorTransformer = {
    from: function (errors, intl) {
        var _a, _b;
        var validationErrors = {};
        var _loop_1 = function (path) {
            var errorMessage = (_a = errors[path], (_a !== null && _a !== void 0 ? _a : ''));
            var pathArray = path.includes('.') ? path.split('.') : [path];
            var lastNestedField = pathArray[pathArray.length - 1];
            if ((_b = intl.messages) === null || _b === void 0 ? void 0 : _b[errorMessage]) {
                errorMessage = intl.formatMessage({ id: errorMessage });
            }
            if (!path || !errorMessage) {
                throw new Error('The validation error is not formatted correctly!');
            }
            pathArray.reduce(function (field, nestedField) {
                return (field[nestedField] = nestedField === lastNestedField ? { __errors: [errorMessage] } : {});
            }, validationErrors);
        };
        for (var path in errors) {
            _loop_1(path);
        }
        return validationErrors;
    },
};
exports.default = enquiryFormErrorTransformer;
